import * as React from 'react'

import { LoanOffer } from 'embed/constants/models'

import { BRAND_COLOR } from 'embed/components/LoadingIndicator'
import { LoanOfferListContainer } from 'embed/components/LoanOfferList/container'
import SeeAllOffersButton from 'embed/components/SeeAllOffersButton'
import Header from '../Application/Header'
import LoanOfferListItem from '../ListItem'
import LoanFilter from '../LoanFilter/container'

interface Props {
  dispatchOfferCta: (offer: LoanOffer) => void
  loanOffers: LoanOffer[]
  seeMoreOffersAvailable: boolean
  seeAllOffersAvailable: boolean
  dispatchSeeAllLoansSelected: () => void
}

export const LoanPreviewView: React.FC<Props> = ({
  dispatchOfferCta,
  dispatchSeeAllLoansSelected,
  loanOffers,
  seeAllOffersAvailable,
}) => (
  <div>
    <Header />
    <LoanFilter />
    <LoanOfferListContainer
      dispatchOfferCta={dispatchOfferCta}
      brandColor={BRAND_COLOR.TRUE}
      ctaButtonText="Continue"
      ctaLabel="Check if you can be approved in less than one minute"
      loanOffers={loanOffers}
      listItem={LoanOfferListItem}
      showSeeMoreOffers={true}
    />
    {seeAllOffersAvailable && <SeeAllOffersButton handleSeeMoreOffers={dispatchSeeAllLoansSelected} />}
  </div>
)
